// Режимы работы компонента
export const MODE_VIEW = 'view';
export const MODE_CREATE = 'create';
export const MODE_UPDATE = 'edit';

export const REQUIRED_STATUS = 'main';
export const DISABLED_STATUS = 'disabled';
